import { PermissionState } from './types';
import { RouteRecordRaw } from 'vue-router';
import { defineStore } from 'pinia';
import { constantRoutes } from '@/router';

const modules = import.meta.glob('../../views/**/**.vue');
const usePermissionStore = defineStore('permission',{
  state: ():any  => ({})
});

export default usePermissionStore